import { pickProps } from "../utils/miscUtil";
export function pickTriggerProps(props) {
  return pickProps(props, ['placement', 'builtinPlacements', 'popupAlign', 'getPopupContainer', 'transitionName', 'direction']);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/PickerTrigger/util.js
// module id = 1048
// module chunks = 0